import * as React from 'react';
import { LDFlagSet } from 'launchdarkly-js-sdk-common';
import {
  getPercentageColor,
  // getUpArrow,
  getBlackFriday,
} from './case4CauseHelpers';

import { urlSvg } from '../../../../server/utils/urlConstants';

// const imgUrlBlueCheck = `${urlSvg}bottleBlueCheck.svg`;
const imgUrlSixthGrey = `${urlSvg}bottleGrayMid.svg`;
const imgUrlTwelfthGrey = `${urlSvg}bottleGrayLast.svg`;
const imgUrlSixthBlack = `${urlSvg}bottleBlackMid.svg`;
const imgUrlTwelfthBlack = `${urlSvg}bottleBlackLast.svg`;
const imgUrlFourthGrey = `${urlSvg}bottleGray4.svg`;
const imgUrlFourthBlack = `${urlSvg}bottleBlack4.svg`;
const imgUrlFourthBlue = `${urlSvg}bottleBlue4.svg`;
const imgUrlSixthBlue = `${urlSvg}bottleBlueMid.svg`;
const imgUrlTwelfthBlue = `${urlSvg}bottleBlueLast.svg`;

type Case4CausePercentageComponentProps = {
  imgPath: string;
  isDiscount20: boolean;
  flags?: LDFlagSet;
  isDiscount10?: boolean;
  isDiscount5?: boolean;
  index?: number;
};

export const Case4CauseFivePercent = ({
  imgPath,
  flags,
}: Case4CausePercentageComponentProps) => {
  if (
    imgPath === imgUrlFourthBlue ||
    imgPath === imgUrlFourthGrey ||
    imgPath === imgUrlFourthBlack
  ) {
    const percentage = getBlackFriday(flags) ? '10%' : '5%';
    return (
      <span className={getPercentageColor(imgPath)}>
        <span className="percentage">{percentage}</span>
      </span>
    );
  }
  return null;
};

export const Case4CauseTenPercent = ({
  imgPath,
  flags,
}: Case4CausePercentageComponentProps) => {
  if (
    imgPath === imgUrlSixthBlue ||
    imgPath === imgUrlSixthGrey ||
    imgPath === imgUrlSixthBlack
  ) {
    const percentage = getBlackFriday(flags) ? '20%' : '10%';
    return (
      <span className={getPercentageColor(imgPath)}>
        <span className="percentage">{percentage}</span>
      </span>
    );
  }
  return null;
};

export const Case4CauseTwentyPercent = ({
  imgPath,
  flags,
}: Case4CausePercentageComponentProps) => {
  if (
    imgPath === imgUrlTwelfthBlue ||
    imgPath === imgUrlTwelfthGrey ||
    imgPath === imgUrlTwelfthBlack
  ) {
    const percentage = getBlackFriday(flags) ? '35%' : '20%';
    return (
      <span className={getPercentageColor(imgPath)}>
        <span className="percentage">{percentage}</span>
      </span>
    );
  }
  return null;
};
